import { Navigate } from 'react-router';
import { FullScreenLoader } from '@/components/FullScreenLoader';
import { Button } from '@/components/ui/button';
import { useLocalsQuery } from '@/lib/locals';
import { getLastLocalId } from '@/lib/token';

/** `/`: manda al último local usado, al primero, o al onboarding si no tiene ninguno. */
export function HomeRedirect() {
  const { data: locals, isPending, error, refetch } = useLocalsQuery();

  if (isPending) return <FullScreenLoader />;
  if (error) {
    return (
      <div className="flex min-h-dvh flex-col items-center justify-center gap-3 p-6 text-center">
        <p className="text-sm text-muted-foreground">No pudimos cargar tus locales.</p>
        <Button onClick={() => refetch()}>Reintentar</Button>
      </div>
    );
  }
  if (locals.length === 0) return <Navigate to="/onboarding" replace />;

  const last = getLastLocalId();
  const target = locals.find((l) => l.id === last) ?? locals[0]!;
  return <Navigate to={`/l/${target.id}/resumen`} replace />;
}
